export const classNames = (...names: (string | undefined | null)[]) => names.filter((name) => name).join(' ')
